import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { api } from "@/lib/api";

export type SearchKind =
  | "document" | "article" | "thread" | "indicator" | "project" | "person";

export interface SearchHit {
  kind: SearchKind;
  id: string;
  title: string;
  snippet: string;
  link: string;
}

interface SearchResponse {
  q: string;
  results: SearchHit[];
}

/** GET /api/v1/search/?q= — cross-domain typeahead. */
export function useGlobalSearch(q: string, opts: { limit?: number } = {}) {
  const trimmed = q.trim();
  return useQuery<SearchResponse>({
    enabled: trimmed.length >= 2,
    queryKey: ["search", trimmed, opts.limit ?? 5],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = new URLSearchParams({ q: trimmed });
      if (opts.limit) params.set("limit", String(opts.limit));
      const { data } = await api.get<SearchResponse>(`/search/?${params.toString()}`);
      return data;
    },
    staleTime: 30_000,
  });
}
